import {
  APP_REPORT_DETAIL_FETCH_REQUEST,
  APP_REPORT_DETAIL_FETCH_REQUEST_SUCCESS,
  APP_REPORT_DETAIL_FETCH_REQUEST_FAILURE,
  APP_REPORT_DETAIL_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const appReportDetailsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case APP_REPORT_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case APP_REPORT_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case APP_REPORT_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case APP_REPORT_DETAIL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default appReportDetailsReducer;
